{
  "name": "react-frontend",
  "version": "1.0.0-SNAPSHOT",
  "private": true,
  "engines": {
    "node": ">=22.22.1"
  },
  "scripts": {
    "eslint:check": "eslint . --ext .ts,.tsx --ignore-pattern /src/__generated__/**",
    "eslint:fix": "eslint . --ext .ts,.tsx --ignore-pattern /src/__generated__/** --fix",
    "prettier:check": "prettier --check --ignore-unknown \"src/**/*.{ts,tsx}\"",
    "prettier:fix": "prettier --write --ignore-unknown \"src/**/*.{ts,tsx}\"",
    "lint": "yarn eslint:check && yarn prettier:check",
    "lint:fix": "yarn eslint:fix && yarn prettier:fix",
    "start": "vite",
    "build": "vite build",
    "docker:test": "./scripts/docker_test.sh",
    "test": "vitest",
    "test:ci": "vitest run --coverage --bail=1",
    "test-e2e": "rm -rf cypress/screenshots cypress/videos && cypress run --browser chromium --config video=false",
    "debug-e2e": "cypress open",
    "install:prod": "HUSKY=0 yarn install --frozen-lockfile --prod",
    "install:ci": "HUSKY=0 yarn install --frozen-lockfile",
    "prepare": "if [ \"$CI\" = \"true\" ] || [ \"$HUSKY\" = \"0\" ] || [ \"$HUSKY_SKIP_INSTALL\" = \"1\" ]; then exit 0; fi; husky",
    "generate-types": "graphql-codegen",
    "storybook": "storybook dev -p 9009",
    "build-storybook": "storybook build",
    "scan-translations": "i18next-scanner --config src/i18next-scanner.config.js",
    "check-translations": "node ./src/check-translations.js",
    "check-translation-plurals": "node ./scripts/check-translation-plurals.js"
  },
  "dependencies": {
    "@apollo/client": "^4.2.3",
    "@emotion/react": "11.14.0",
    "@emotion/styled": "11.14.1",
    "@googlemaps/js-api-loader": "^2.1.1",
    "@hello-pangea/dnd": "^18.0.1",
    "@mui/icons-material": "^9.1.1",
    "@mui/material": "^9.1.1",
    "@mui/x-date-pickers": "^9.5.0",
    "@react-oauth/google": "0.13.5",
    "@tanstack/react-table": "8.21.3",
    "ace-builds": "1.44.0",
    "apollo-upload-client": "^19",
    "classnames": "2.5.1",
    "dayjs": "1.11.21",
    "decimal.js": "10.6.0",
    "fabric": "^7.4.0",
    "formik": "2.4.9",
    "google-map-react": "2.2.5",
    "graphql": "16.14.1",
    "highlight.js": "11.11.1",
    "husky": "^9.1.7",
    "i18next": "^26.3.1",
    "i18next-scanner": "4.6.0",
    "i18next-scanner-typescript": "1.2.1",
    "jszip": "^3.10.1",
    "lodash-es": "^4.18.1",
    "md5": "^2.3.0",
    "moment": "^2.30.1",
    "mui-color-input": "^9.0.0",
    "react": "^19.2.7",
    "react-ace": "^14.0.1",
    "react-day-picker": "^10.0.0",
    "react-dom": "^19.2.7",
    "react-geocode": "^2.0.0",
    "react-helmet": "^6.1.0",
    "react-i18next": "^17.0.8",
    "react-image-crop": "^11.0.0",
    "react-is": "^19.2.7",
    "react-router-dom": "^7.18.0",
    "recharts": "^3.1.2",
    "rxjs": "^7.8.2",
    "typescript": "^5.6.3",
    "use-debounce": "^10.0.0",
    "uuid": "^14.0.0",
    "write-excel-file": "^4.0.7",
    "yup": "^1.6.0"
  },
  "devDependencies": {
    "@graphql-codegen/add": "^7.0.1",
    "@graphql-codegen/cli": "^7.1.3",
    "@graphql-codegen/typescript": "^6.0.2",
    "@graphql-codegen/typescript-operations": "^6.0.4",
    "@graphql-codegen/typescript-react-apollo": "^4.0.0",
    "@storybook/addon-docs": "^10.4.6",
    "@storybook/react-vite": "^10.4.6",
    "@testing-library/dom": "^10.4.1",
    "@testing-library/jest-dom": "6.9.1",
    "@testing-library/react": "16.3.2",
    "@testing-library/user-event": "14.6.1",
    "@types/classnames": "2.3.4",
    "@types/google-map-react": "2.1.10",
    "@types/invariant": "2.2.37",
    "@types/lodash-es": "4.17.12",
    "@types/md5": "2.3.6",
    "@types/node": "^22.15.0",
    "@types/react": "^19.2.17",
    "@types/react-dom": "^19.2.3",
    "@types/react-helmet": "6.1.11",
    "@types/react-tabs": "2.3.4",
    "@types/webpack-env": "1.18.8",
    "@typescript-eslint/eslint-plugin": "8.61.1",
    "@typescript-eslint/parser": "8.61.1",
    "@vitejs/plugin-react": "6.0.2",
    "@vitest/coverage-v8": "4.1.9",
    "caniuse-lite": "^1.0.30001799",
    "cypress": "^15.17.0",
    "dotenv": "^17.2.3",
    "eslint": "9",
    "eslint-config-prettier": "10",
    "eslint-plugin-prettier": "5",
    "eslint-plugin-react": "7.37.5",
    "history": "^5",
    "identity-obj-proxy": "^3.0.0",
    "jest-canvas-mock": "2.5.2",
    "jsdom": "29.1.1",
    "lint-staged": "17",
    "prettier": "3.8.4",
    "storybook": "^10.4.6",
    "vite": "8.0.16",
    "vite-plugin-svgr": "5.2.0",
    "vitest": "4.1.9",
    "vitest-canvas-mock": "^1.1.4"
  },
  "resolutions": {
    "caniuse-lite": "^1.0.30001799"
  },
  "browserslist": [
    ">0.2%",
    "not dead",
    "not ie <= 11",
    "not op_mini all"
  ],
  "lint-staged": {
    "*.{ts,tsx}": [
      "eslint --cache --fix"
    ]
  },
  "packageManager": "yarn@1.22.22+sha512.a6b2f7906b721bba3d67d4aff083df04dad64c399707841b7acf00f6b133b7ac24255f2652fa22ae3534329dc6180534e98d17432037ff6fd140556e2bb3137e"
}
